import { I18nMessages, I18nProviderFunction } from "../../utils/i18n";

export interface AppHeaderTranslations extends I18nMessages {
    closeButton: string;
    helpLabel: string;
    homeLabel: string;
    logoutButton: string;
    notificationsLabel: string;
    noUserDataLabel: string;
    settingsLabel: string;
    userLabel: string;
    userProfileLinkText: string;
}

export const getTranslations: I18nProviderFunction = async (locale: string): Promise<AppHeaderTranslations> => {
    let module: { default: AppHeaderTranslations };
    switch (locale.replace("-", "_").valueOf()) {
        case "de":
        case "de_DE":
            module = await import("./i18n/de");
            return module.default;
        case "en":
        case "en_GB":
        case "en_US":
        default:
            module = await import("./i18n/en");
            return module.default;
    }
};
